// src/firebase.js - Using default database
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAmFfrkBGhHuaWIo_xUfkCzQY2qz7omxEM",
  authDomain: "cte-completer-app.firebaseapp.com",
  projectId: "cte-completer-app",
  storageBucket: "cte-completer-app.firebasestorage.app",
  messagingSenderId: "234586142876",
  appId: "1:234586142876:web:d12d27418e05eb40d1d559" };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Use default database
const storage = getStorage(app);
const auth = getAuth(app);

export { app, db, storage, auth };